export const CloseIcon = props => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_5875_20316"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="17"
      height="16"
    >
      <rect x="0.5" width="16" height="16" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_5875_20316)">
      <path
        d="M8.50003 8.9333L5.23337 12.2C5.11114 12.3222 4.95559 12.3833 4.7667 12.3833C4.57781 12.3833 4.42225 12.3222 4.30003 12.2C4.17781 12.0777 4.1167 11.9222 4.1167 11.7333C4.1167 11.5444 4.17781 11.3889 4.30003 11.2666L7.5667 7.99997L4.30003 4.7333C4.17781 4.61108 4.1167 4.45553 4.1167 4.26664C4.1167 4.07775 4.17781 3.92219 4.30003 3.79997C4.42225 3.67775 4.57781 3.61664 4.7667 3.61664C4.95559 3.61664 5.11114 3.67775 5.23337 3.79997L8.50003 7.06664L11.7667 3.79997C11.8889 3.67775 12.0445 3.61664 12.2334 3.61664C12.4223 3.61664 12.5778 3.67775 12.7 3.79997C12.8223 3.92219 12.8834 4.07775 12.8834 4.26664C12.8834 4.45553 12.8223 4.61108 12.7 4.7333L9.43337 7.99997L12.7 11.2666C12.8223 11.3889 12.8834 11.5444 12.8834 11.7333C12.8834 11.9222 12.8223 12.0777 12.7 12.2C12.5778 12.3222 12.4223 12.3833 12.2334 12.3833C12.0445 12.3833 11.8889 12.3222 11.7667 12.2L8.50003 8.9333Z"
        fill="black"
      />
    </g>
  </svg>
);
